module.exports = {"object":"value","document":{"object":"document","nodes":[{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"In addition to block nodes, you can create inline void nodes, like "},{"object":"inline","type":"emoji","data":{"code":"😃"}},{"object":"text","text":"!"}]},{"object":"block","type":"paragraph","nodes":[{"object":"inline","type":"emoji","data":{"code":"🍔"}}]},{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"This example shows emojis in action."}]}]}}


//////////////////
// WEBPACK FOOTER
// ./examples/emojis/value.json
// module id = 762
// module chunks = 0